import React from 'react';
import { Card, CardContent } from '../ui/card';
import { X } from 'lucide-react';

const ProfileError = () => {
  return (
    <div className="max-w-2xl mx-auto">
      <Card>
        <CardContent className="p-6">
          <div className="text-center">
            <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-lg flex items-center justify-center mx-auto mb-4">
              <X className="w-6 h-6 text-red-600 dark:text-red-400" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
              Unable to load profile
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              We couldn't load your profile data. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProfileError;
